var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("label", { class: _vm.checkboxClasss }, [
    _c("span", { staticClass: "mku-checkbox-content" }, [
      _c("span", { staticClass: "mku-checkbox" }, [
        _c("span", { staticClass: "mku-checkbox-inner" }),
        _vm._v(" "),
        _vm.isGroup
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.checkboxSelectedArray,
                  expression: "checkboxSelectedArray"
                }
              ],
              staticClass: "mku-checkbox-input",
              attrs: { type: "checkbox", disabled: _vm.disabled },
              domProps: {
                value: _vm.label,
                checked: Array.isArray(_vm.checkboxSelectedArray)
                  ? _vm._i(_vm.checkboxSelectedArray, _vm.label) > -1
                  : _vm.checkboxSelectedArray
              },
              on: {
                change: [
                  function($event) {
                    var $$a = _vm.checkboxSelectedArray,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = _vm.label,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          (_vm.checkboxSelectedArray = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.checkboxSelectedArray = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.checkboxSelectedArray = $$c
                    }
                  },
                  _vm.handleCheckboxChange
                ]
              }
            })
          : _c("input", {
              staticClass: "mku-checkbox-input",
              attrs: { type: "checkbox", disabled: _vm.disabled },
              domProps: { checked: _vm.checkboxValue },
              on: { change: _vm.handleCheckboxChange }
            })
      ]),
      _vm._v(" "),
      _c("span", [_vm._t("default")], 2)
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }